import { IMPORT_STARTED, TOKEN_NAME } from "../constants/importerConstants";

type GoogleClassroomCourse = {
  id?: string;
  name?: string;
  description?: string;
};

type GoogleClassroomStudent = {
  profile?: {
    name?: { fullName?: string };
    emailAddress?: string;
  };
};

type FormattedCourse = {
  id: string | null;
  name: string | null;
  description: string;
};

type FormattedStudent = {
  name: string | null;
  email: string | null;
};

type ParsedOAuthState = {
  storedState: unknown;
  stateFromUrl: unknown;
};

export const formatCourse = (
  course: GoogleClassroomCourse | null | undefined,
): FormattedCourse => {
  return {
    id: course?.id || null,
    name: course?.name || null,
    description: course?.description || "",
  };
};

export const formatStudents = (
  studentData: GoogleClassroomStudent[],
): FormattedStudent[] => {
  return studentData.map((student) => {
    return {
      name: student?.profile?.name?.fullName || null,
      email: student?.profile?.emailAddress || null,
    };
  });
};

export const clearImportDataFromSession = (): void => {
  sessionStorage.removeItem(IMPORT_STARTED);
  sessionStorage.removeItem(TOKEN_NAME);
};

export const parseOAuthState = (
  stateParam: string | null,
  storedStateRaw: string | null,
): ParsedOAuthState => {
  let stateFromUrl: unknown = null;
  let storedState: unknown = null;

  if (stateParam) {
    try {
      stateFromUrl = JSON.parse(decodeURIComponent(stateParam));
    } catch (error) {
      console.warn("Unable to parse state from URL", error);
    }
  }

  if (storedStateRaw) {
    try {
      storedState = JSON.parse(storedStateRaw);
    } catch (error) {
      console.warn("Unable to parse stored OAuth state", error);
    }
  }

  return { storedState, stateFromUrl };
};
